<div class="modalOverlay">
    <div class="modalPositioner" cvNavigationSidebarClass>
        <div class="modalContainer">
            <!-- Header -->
            <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail modal-close" (click)="cancel()">
                <svg class="icon-16">
                    <use href="../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
                </svg>
            </button>
            <div class="modal-header">
                <span class="titleText" cvLocalizedText [langSection]="'CXOne_Dashboard'" [langKey]="'Delete_Subscription'">Delete Subscription</span>
            </div>
            <!-- Header End -->

            <!-- Body -->
            <div class="modal-body">
                <div class="body-row" cvLocalizedText [langSection]="'Subscription_Modal'" [langKey]="'Delete_Confirmation'">Are you sure you want to delete subscription?</div>
                <div class="body-row" cvLocalizedText [langSection]="'Subscription_Modal'" [langKey]="'Users_Message'">This action will affect all the users listed</div>
                <div class="body-row recipient-list">
                    <div class="recipient-item" *ngFor="let email of recipientEmails">{{ email }}</div>
                </div>
            </div>
            <!-- Body End -->

            <!-- Footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-text mr-2" (click)="cancel()" cvLocalizedText [langSection]="'Common'" [langKey]="'Cancel_Button'">Cancel</button>
                <button type="button" class="btn btn-primary" (click)="approve()" cvLocalizedText [langSection]="'Subscription_Modal'" [langKey]="'Approve'">Approve</button>
            </div>
            <!-- Footer End -->
        </div>
    </div>
</div>
